import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createStructureType = ({ denominationId, structureTypeData }) => {
  return axios.post(
    `/denominations/${denominationId}/structure-types`,
    structureTypeData
  );
};

export const useCreateStructureType = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["structure-types"]);
      queryClient.invalidateQueries(["structure-types-paginated"]);

      setNotification({
        type: "success",
        message: "Structure type created successfully!"
      });
    },
    ...config,
    mutationFn: createStructureType
  });
};
